import { extendTheme } from "@chakra-ui/react"

export default extendTheme({
    
});